'use strict';
import React from 'react';
import classnames from 'classnames';
import ReactCSSTransitionGroup from 'react/lib/ReactCSSTransitionGroup';

var mediaListingItemNotification = React.createClass({
    displayName: 'mediaListingItemNotification',

    propTypes: {
        notifications: React.PropTypes.array
    },

    render() {
        const { notifications } = this.props;

        if ( !notifications || 0 === notifications.length ) {
            return false;
        }

        return (
            <div className="notifications">
                <ReactCSSTransitionGroup transitionName="transition__notifications">
                {notifications.map( notification => {
                    return (
                        <div key={notification.id} className={classnames('notifications--' + notification.type)}>
                            {notification.text}
                        </div>);
                })}
                </ReactCSSTransitionGroup>
            </div>
        );
    }

});

module.exports = mediaListingItemNotification;



// WEBPACK FOOTER //
// ./app/pages/media/mediaListingItemNotification.jsx